// Auth Action Types
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CAPTCHA = "CAPTCHA";
export const PASSWORD_GENERATE = "PASSWORD_GENERATE";
export const PROFILEDEATAILS = "PROFILEDEATAILS";
export const EDITPASSWORD = "EDITPASSWORD";
export const SET_ADMIN_ID = "SET_ADMIN_ID";
export const HANDLEDRAWER = "HANDLEDRAWER";
export const SETMOBILE = "SETMOBILE";
export const SET_ALL_ORG = "SET_ALL_ORG";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_ORG_DETAILS = "SET_ORG_DETAILS";
export const SET_ORG_USER_DEATILS = "SET_ORG_USER_DEATILS";
export const SET_ORG_ID = "SET_ORG_ID";
export const SET_ALL_DATA = "SET_ALL_DATA";
export const SET_USER = "SET_USER";
export const SET_ORG = "SET_ORG";
export const SETLOGINORG = "SETLOGINORG";
export const SET_ORG_USER_DETAILS = "SET_ORG_USER_DETAILS";
export const SET_ORG_DETAILS2 = "SET_ORG_DETAILS2";
export const VIEW_ALL_DEPARTMENT = "VIEW_ALL_DEPARTMENT";
export const VIEW_ALL_PRIORITY = "VIEW_ALL_PRIORITY";
export const VIEW_ALL_STATUS = "VIEW_ALL_STATUS";
export const SET_DOC = "SET_DOC";
export const LOGIN_STATUS = "LOGIN_STATUS";
export const SET_PASSWORD = "SET_PASSWORD";
export const SET_EMAIL = "SET_EMAIL";
export const SET_HOME = "SET_HOME";
export const SET_ORGANIZATIONS = "SET_ORGANIZATIONS";
export const SET_WALET_BY_ID = "SET_WALET_BY_ID";

// Client/Links Action Types
export const ALLLINKS = "ALLLINKS";
export const ALLLINKSBYUSER = "ALLLINKSBYUSER";
export const THANKYOU = "THANKYOU";
export const ALLREVIEWS = "ALLREVIEWS";
export const BADFEEDBACK = "BADFEEDBACK";
export const ALLLINKSBYADMIN = "ALLLINKSBYADMIN";
export const VIEW_BY_ID = "VIEW_BY_ID";
export const MODAL = "MODAL";
export const VIEWNAVITEMBYID = "VIEWNAVITEMBYID";
export const VIEWTITLE = "VIEWTITLE";
export const LOGEDIN_DEVICE = "LOGEDIN_DEVICE";

// Snackbar Helpers
export const SET_SNACK_BAR = "SET_SNACK_BAR";
export const CLOSE_SNACK_BAR = "CLOSE_SNACK_BAR";
export const LOADER = "LOADER";
